import type { AppLanguageCode, TKey } from '@/lib/i18n'

export const CHANGELOG_ENTRIES = [
	{
		version: 'v1.4.0',
		publishedAt: '2026-06-30',
		titleKey: 'common:changelog.entries.v1_4_0.title',
		itemKeys: [
			'common:changelog.entries.v1_4_0.item_1',
			'common:changelog.entries.v1_4_0.item_2',
			'common:changelog.entries.v1_4_0.item_3'
		]
	},
	{
		version: 'v1.3.0',
		publishedAt: '2026-06-02',
		titleKey: 'common:changelog.entries.v1_3_0.title',
		itemKeys: [
			'common:changelog.entries.v1_3_0.item_1',
			'common:changelog.entries.v1_3_0.item_2',
			'common:changelog.entries.v1_3_0.item_3'
		]
	},
	{
		version: 'v1.2.0',
		publishedAt: '2026-04-28',
		titleKey: 'common:changelog.entries.v1_2_0.title',
		itemKeys: [
			'common:changelog.entries.v1_2_0.item_1',
			'common:changelog.entries.v1_2_0.item_2',
			'common:changelog.entries.v1_2_0.item_3'
		]
	}
] as const satisfies ReadonlyArray<{
	version: string
	publishedAt: string
	titleKey: TKey
	itemKeys: readonly TKey[]
}>

export function formatChangelogDate(
	publishedAt: string,
	language: AppLanguageCode
) {
	return new Intl.DateTimeFormat(language, {
		dateStyle: 'long',
		timeZone: 'UTC'
	}).format(new Date(`${publishedAt}T00:00:00.000Z`))
}
